// categoriesSaga.ts

import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { API } from '../../api';
import {
  createCategoryTemplate,
  createCategoryTemplateFailure,
  createCategoryTemplateSuccess,
  getCategoryTemplates,
  getCategoryTemplatesFailure,
  getCategoryTemplatesSuccess,
  removeCategoryTemplate,
  removeCategoryTemplateFailure,
  removeCategoryTemplateSuccess,
  updateCategoryTemplate,
  updateCategoryTemplateFailure,
  updateCategoryTemplateSuccess,
} from '../reducers/categoryTemplatesSlice';

import { errorHandler } from './common';

function* getCategoryTemplatesSaga () {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, '/category-templates/', {
      params: {
        includeServices: 'true',
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(getCategoryTemplatesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: getCategoryTemplatesSaga,
      *callback () {
        yield put(getCategoryTemplatesFailure(error));
      },
    });
  }
}

interface createCategoryTemplateSagaProp {
  payload: {
    title: string;
    image?: string;
    parentId?: number;
    onSuccess: (id: any) => void;
    onFailure: (error: any) => void;
  };
}

function* createCategoryTemplateSaga ({
  payload: { title, image, parentId, onSuccess, onFailure },
}: createCategoryTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(
      API.post,
      `/category-templates`,
      {
        title,
        image: image && image,
        parent: parentId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    yield put(createCategoryTemplateSuccess());
    onSuccess(response.data.data);
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield createCategoryTemplateSaga({
          payload: { title, image, parentId, onSuccess, onFailure },
        });
      },
      *callback () {
        yield put(createCategoryTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

interface updateCategoryTemplateSagaProp {
  payload: {
    categoriesId: string;
    title?: string;
    image?: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* updateCategoryTemplateSaga ({
  payload: { categoriesId, title, image, onSuccess, onFailure },
}: updateCategoryTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.patch,
      `/category-templates/${categoriesId}`,
      {
        title,
        image: image && image
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    yield put(updateCategoryTemplateSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield updateCategoryTemplateSaga({
          payload: {
            categoriesId,
            title,
            image,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(updateCategoryTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

interface removeCategoryTemplateSagaProp {
  payload: {
    categoriesId: number;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* removeCategoryTemplateSaga ({
  payload: { categoriesId, onSuccess, onFailure },
}: removeCategoryTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(API.delete, `/category-templates/${categoriesId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(removeCategoryTemplateSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield removeCategoryTemplateSaga({
          payload: { categoriesId, onSuccess, onFailure },
        });
        onFailure(error);
      },
      *callback () {
        yield put(removeCategoryTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* categoryTemplatesSaga () {
  // @ts-ignore
  yield takeLatest(getCategoryTemplates().type, getCategoryTemplatesSaga);
  // @ts-ignore
  yield takeEvery(createCategoryTemplate().type, createCategoryTemplateSaga);
  // @ts-ignore
  yield takeEvery(updateCategoryTemplate().type, updateCategoryTemplateSaga);
  // @ts-ignore
  yield takeEvery(removeCategoryTemplate().type, removeCategoryTemplateSaga);
}
